export default defineNuxtPlugin(() => {
  const { $i18n } = useNuxtApp();

  $i18n.onLanguageSwitched = (_oldLocale, newLocale) => {
    window.smartsupp('language', newLocale);

    return Promise.resolve();
  };
});
